import Vue from "vue";
import jwtDecode from "jwt-decode";
import VueRouter from "vue-router";
import rolesRouter from "../views/roles/rolesRouter";
import profilesRouter from "../views/profiles/profilesRouter";
import usersRouter from "../views/users/userRouter";
import contratosRouter from "../views/contratos/contratoRouter";
import pathsRouter from "../views/paths/pathRouter";
import routerSolicitudes from '../views/solicitudes/routers'
import routerNombramientos from '../views/nombramientos/router'
import "@/plugins/frontendRoles";
import authServices from "../services/auth.services.js";
import candidatorNoContratadosRouter from "../views/candidatos-no-contratados/router";
import historialEvaluacionesCandidatosRouter from "../views/historial-evaluaciones-candidatos/router";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        component: () => import(/* webpackChunkName: "layout" */ "../views/layout"),
        children: [
            {
                path: "/",
                name: "dashboard",
                component: () =>
                    import(/* webpackChunkName: "profiles" */ "../views/dashboard"),
            },
            {
                path: "/choose-job",
                name: "selectPuesto",
                component: () =>
                    import(/* webpackChunkName: "profiles" */ "../views/auth/selectPuesto")
            },
            {
                path: "profile",
                name: "profile",
                component: () =>
                    import(/* webpackChunkName: "profiles" */ "../views/profile"),
            },
            ...rolesRouter,
            ...profilesRouter,
            ...usersRouter,
            ...pathsRouter,
            ...contratosRouter,
            ...routerSolicitudes,
            ...routerNombramientos,
            ...candidatorNoContratadosRouter,
            ...historialEvaluacionesCandidatosRouter,
            {
                path: "/security",
                name: "security",
                component: () => import(/* webpackChunkName: "qr" */ "../views/auth/security"),
            },
        ],
    },
    {
        path: "/login",
        name: "login",
        component: () => import(/* webpackChunkName: "login" */ "../views/auth/login"),
    },
    {
        path: "/forgot-password",
        name: "forgot-password",
        component: () =>
            import(
                /* webpackChunkName: "recuperarPassword" */ "../views/auth/recoverPassword"
            ),
    },
    {
        path: "/reset-password/:id",
        name: "reset-password",
        component: () =>
            import(/* webpackChunkName: "resetPassword" */ "../views/auth/resetPassword"),
    },
    {
        path: "/verify-mail/:token",
        name: "verifyMail",
        component: () =>
            import(/* webpackChunkName: "login" */ "../views/auth/verifyMail"),
    },
    {
        path: "/forbidden",
        name: "Forbidden",
        component: () =>
            import(/* webpackChunkName: "forbidden" */ "../views/forbidden"),
    },
    {
        path: "/notFound",
        name: "NotFound",
        component: () =>
            import(/* webpackChunkName: "notFound" */ "../views/notFound.vue"),
    },
    {
        path: "/autenticacionqr",
        name: "2fa",
        component: () => import(/* webpackChunkName: "qr" */ "../views/auth/2fa"),
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

router.beforeEach(async (to, from, next) => {
    const path = to.fullPath.substring(1);
    const session = to.query.session || null;
    const token = localStorage.getItem("token");

    if (session) {
        localStorage.removeItem("token");
        localStorage.removeItem("refresh_token");
        localStorage.setItem("session_uuid", session);

        const queryWithoutSession = Object.assign({}, to.query);
        delete queryWithoutSession.session;
        try {
            const response = await authServices.obtenerSesionPorUUID(session);
            if (response.data?.token) {
                localStorage.setItem("token", response.data.token);
                localStorage.setItem("refresh_token", response.data.refreshToken);
                localStorage.removeItem("roles");
                localStorage.removeItem("menu");
            }
        } catch (error) {
            console.error("Error al obtener la sesión:", error);
        }

        next({ path: to.path, query: queryWithoutSession, replace: true });
        return;
    }

    if (path.startsWith('https')) {
        window.location.replace(path)
    }

    if (to.fullPath === "/") {
        if (!token) {
            next("/login");
            return;
        }
    }
    if (await Vue.prototype.canNext(to)) {
        next();
    } else {
        next("/notFound");
    }

    ('rol' in to.meta)
        ? (await Vue.prototype.validRol(to.meta.rol))
            ? next()
            : next("/forbidden")
        : next();
});

export default router;
